var _style, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#E5E5E5;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M600,1200c331.1,0,600-268.9,600-600C1200,268.8,931.1,0,600,0C268.8,0,0,268.9,0,600S268.9,1200,600,1200z  M672.3,736.7L535,599.4l136.1-136.1c23.5-23.4,23.5-61.4,0-84.8c-23.4-23.5-61.4-23.5-84.8,0L407.7,557 c-23.4,23.5-23.4,61.4,0,84.9l179.7,179.6c23.5,23.5,61.4,23.5,84.9,0C695.7,798.1,695.7,760.1,672.3,736.7L672.3,736.7z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.f8f1cddbb937ee383c6d13efece7cfae.svg";
export { ForwardRef as ReactComponent };